import { createAction } from 'redux-actions';
import { getItemList } from '../api/items';

import { GET_CONTENTS_SUCCESS, GET_CONTENTS_FAILURE } from '../constants/actionTypes';

const getContentSuccess = createAction(GET_CONTENTS_SUCCESS);
const getContentFailure = createAction(GET_CONTENTS_FAILURE);

export function getContents() {
  return dispatch => getItemList('contents')
    .then((json) => dispatch(getContentSuccess({ ...json })))
    .catch(error => dispatch(getContentFailure(error)))
}
